import React from 'react';
import { connect } from "react-redux";
import Split from "react-split-it";
import CustomerOrderInProgressSpreadsheet from '../CustomerOrderInProgress/CustomerOrderInProgressSpreadsheet';
import CustomerOrderNewOrdersSpreadsheet from '../CustomerOrderNewOrders/CustomerOrderNewOrdersSpreadsheet';
import { customerOrderInProgress } from '../../../../../src/store/actions/customerOrderInProgress/customerOrderInProgress';
import { customerOrderNewOrders } from '../../../../../src/store/actions/customerOrderNewOrders/customerOrderNewOrders';
import { getContentWidth } from '../../../../../src/store/reducers/customerOrderNewOrders/helper/general';
import { useClientHubCustomerPortalNotificationHub } from "../../../hook/hub/useClientHubCustomerPortalNotificationHub";

const CustomerOrders = ({ 
    state, 
    loadingCustomerOrderNewOrders, 
    loadingCustomerOrderInProgress, 
    userId,
    customerOrderInProgress,
    customerOrderNewOrders,
    }) => {    
    const resource = 'customerOrderNewOrders';
    const headers = state[resource].headers;
    const width = getContentWidth(headers);
    const innerWidth = window.innerWidth;

    useClientHubCustomerPortalNotificationHub((message) => {
        if (userId === message.byId && message.actionType === 'REFRESH') {
            customerOrderNewOrders('customerOrder', 'myorderorderlist');
            customerOrderInProgress('customerOrder', 'area');
        }
    }, 'notification');

    const smallScreen = width < innerWidth;
    const content = (
        <div className={`splitter custom-scrollBar spreadsheet__margins ${smallScreen ? 'small-spreedsheet__center__active-orders' : '' }`}>
            <Split
                sizes={[50, 50]}
                direction="vertical"
                gutterSize={(loadingCustomerOrderNewOrders && loadingCustomerOrderInProgress) ? 0: 10}>
                <CustomerOrderInProgressSpreadsheet />
                <CustomerOrderNewOrdersSpreadsheet />
            </Split>
        </div>
    );
    return content;
};

const mapStateToProps = state => ({
    state: state,
    loadingCustomerOrderNewOrders: state.customerOrderNewOrders.loading,
    loadingCustomerOrderInProgress: state.customerOrderInProgress.loading,
    userId: state.auth.userId,
});

const mapDispatchToProps = dispatch => ({
    customerOrderInProgress: (resource, endPoint) => dispatch(customerOrderInProgress(resource, endPoint)),
    customerOrderNewOrders: (resource, endPoint) => dispatch(customerOrderNewOrders(resource, endPoint)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CustomerOrders);